import React from 'react';
import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './components/App';
import "../node_modules/font-awesome/css/font-awesome.min.css"
import './styles/project.scss';

ReactDOM.render(<App />, document.querySelector('#root'));
